import "./list.css";
import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";
import Fab from "@material-ui/core/Fab";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import PropTypes from "prop-types";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import clsx from "clsx";
// import { CoinContext } from "../../contexts/CoinContext";
import Icon from "../../fontIcons/icon";
import { Divider } from "@material-ui/core";
import SVG from "react-inlinesvg";

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  // const trigger = useScrollTrigger({
  //   target: window ? window() : undefined,
  //   disableHysteresis: false,
  //   threshold: 100
  // });

  const handleClick = (event) => {
    // console.log("event?", event.target);
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#go-to-bottom-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div
      onClick={handleClick}
      role="presentation"
      className={classes.downarrow}
    >
      {children}
    </div>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

function CoinList(props) {
  const prices = useSelector((state) => state.priceReducer.PRICES);
  const favList = useSelector((state) => state.trading.FAV_PRICES);
  var data = props.data;
  var tab = props.tab;
  var listLS = JSON.parse(localStorage.getItem("list"));
  let history = useHistory();
  const theme = useTheme();
  const params = useParams();
  const location = useLocation();
  const [currentCoin, setCurrentCoin] = useState(() => params.coin);
  const dispatch = useDispatch();

  useEffect(() => {
    if (params.coin) {
      setCurrentCoin(params.coin);
      dispatch({
        type: "SET_SELECTED_COIN",
        selectedCoin: params.coin,
      });
    } else {
      setCurrentCoin("BTC");
      dispatch({
        type: "SET_SELECTED_COIN",
        selectedCoin: "BTC",
      });
    }
    if (location.pathname.includes("vault")) {
      setCurrentCoin("");
    }
  }, [params.coin]);
  // const [hoverIcon, setHoverIcon] = React.useState(false);

  // console.log("Open", props.position)
  var drawerOpen = props.position;

  useEffect(() => {
    if (
      window.location.pathname.slice(0, 6) === "/trade" &&
      window.location.pathname !== "/trade/:coin"
    ) {
      let paramCoin = window.location.pathname.slice(7);

      if (paramCoin !== currentCoin) {
        setCurrentCoin(paramCoin);
      }
    }
  }, [currentCoin]);

  if (window.location.pathname === "/trade/:coin") {
    history.push(`/trade/${currentCoin}`);
  }

  const classes = useStyles();

  const renderList = (data, prices) => {
    const list = data.map((item) =>
      tab === "MARKETS" ? (
        <div key={item.coinId}>
          <ListItem
            onClick={(e) => {
              e.persist();

              let data = e.target.dataset;
              let parsedData = JSON.parse(JSON.stringify(data));

              if (parsedData.identifier != "star") {
                setCurrentCoin(item.coinId);
                history.push(`/trade/${item.coinId}`);
                dispatch({ type: "SET_MOBILE_TAB", payload: 1 });
                dispatch({
                  type: "SET_SELECTED_COIN",
                  selectedCoin: item.coinId,
                });
              }
            }}
            alignItems="flex-start"
            disableGutters
            key={item.coinId}
            className={classes.drawerList}
            style={{
              background:
                item.coinId === currentCoin
                  ? theme.palette.type === "dark"
                    ? "#2D2F3E"
                    : "#D9D9D9"
                  : null,
              minHeight: "40px", //50px
              maxHeight: "40px", //50px
              alignItems: "center",
            }}
          >
            <ListItemAvatar
              style={{
                maxWidth: "34px",
                minWidth: "34px",
                marginRight: "0px",
                marginTop: "6px",
              }}
            >
              <Tooltip
                title={
                  <span
                    style={{ fontSize: 12, margin: 4, lineHeight: "normal" }}
                  >
                    {item.coinId}
                  </span>
                }
              >
                <span>
                  <img
                    // cacheRequests={true}
                    src={
                      item.coinId == currentCoin
                        ? item.activeIconUrl
                        : item.inactiveIconUrl
                    }
                    width={20}
                    height="auto"
                    alt={item.coinId}
                  />
                  {/* <Icon
                    icon={item.coinId.toLowerCase()}
                    size={26}
                    color={item.coinId === currentCoin ? item.color : "#3AC4AB"}
                  /> */}
                </span>
              </Tooltip>
            </ListItemAvatar>

            <ListItemText
              primary={
                <div
                  style={{
                    display: "flex",
                    overflow: "hidden",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      marginLeft: "5px",
                      minWidth: "52px",
                    }}
                  >
                    <p className={classes.ptitle}>{item.coinId}</p>
                    {/* <p className={classes.pvalue}>{item.stock}%</p> */}
                  </div>

                  <Grid container>
                    <Grid item>
                      <p
                        style={{
                          margin: 0,
                          color: "#3AC4AB",
                          fontSize: "13px",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>Buy: </span>
                        <Tooltip
                          title={
                            <span
                              style={{
                                fontSize: 12,
                                margin: 4,
                                lineHeight: "normal",
                              }}
                            >
                              {prices[`${item.coinId}INR`]
                                ? JSON.stringify(
                                    prices[`${item.coinId}INR`]["a"]
                                  )
                                : null}
                            </span>
                          }
                        >
                          <span>
                            {prices[`${item.coinId}INR`]
                              ? prices[`${item.coinId}INR`]["a"]
                              : null}
                          </span>
                        </Tooltip>
                      </p>
                      <p
                        style={{
                          margin: 0,
                          color: "#D4535A",
                          fontSize: "13px",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>Sell: </span>
                        <Tooltip
                          title={
                            <span
                              style={{
                                fontSize: 12,
                                margin: 4,
                                lineHeight: "normal",
                              }}
                            >
                              {prices[`${item.coinId}INR`]
                                ? JSON.stringify(
                                    prices[`${item.coinId}INR`]["b"]
                                  )
                                : null}
                            </span>
                          }
                        >
                          <span>
                            {prices[`${item.coinId}INR`]
                              ? prices[`${item.coinId}INR`]["b"]
                              : null}
                          </span>
                        </Tooltip>
                      </p>
                    </Grid>
                  </Grid>

                  <Grid justify="flex-end">
                    <Grid item>
                      {favList.includes(item.coinId) ? (
                        <div
                          onClick={(e) => {
                            dispatch({
                              type: "DELETE_FAV_PRICE",
                              payload: item.coinId,
                            });
                          }}
                          data-identifier="star"
                        >
                          <StarIcon
                            style={{
                              marginLeft: "4px",
                              color: "#ffd900",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          data-identifier="star"
                          onClick={() => {
                            dispatch({
                              type: "ADD_FAV_PRICE",
                              payload: item.coinId,
                            });
                          }}
                        >
                          <StarBorderIcon
                            style={{
                              marginLeft: "4px",
                              color: "#A9A9A9",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </div>
              }
            />
          </ListItem>
          {drawerOpen ? <Divider /> : null}
        </div>
      ) : favList.includes(item.coinId) ? (
        <div key={item.coinId}>
          <ListItem
            alignItems="flex-start"
            disableGutters
            key={item.coinId}
            onClick={(e) => {
              e.persist();

              let data = e.target.dataset;
              let parsedData = JSON.parse(JSON.stringify(data));

              if (parsedData.identifier != "star") {
                setCurrentCoin(item.coinId);
                history.push(`/trade/${item.coinId}`);
                dispatch({ type: "SET_MOBILE_TAB", payload: 1 });
                dispatch({
                  type: "SET_SELECTED_COIN",
                  selectedCoin: item.coinId,
                });
              }
            }}
            className={classes.drawerList}
            style={{
              background:
                item.coinId === currentCoin
                  ? theme.palette.type === "dark"
                    ? "#2D2F3E"
                    : "#D9D9D9"
                  : null,
              minHeight: "40px", //50px
              maxHeight: "40px", //50px
              alignItems: "center",
            }}
          >
            <ListItemAvatar
              style={{
                maxWidth: "34px",
                minWidth: "34px",
                marginRight: "0px",
                marginTop: "6px",
              }}
            >
              <Tooltip
                title={
                  <span
                    style={{ fontSize: 12, margin: 4, lineHeight: "normal" }}
                  >
                    {item.coinId}
                  </span>
                }
              >
                {/* {theme.palette.type === "dark" ? (
                <img
                  alt="Coin"
                  src={item.logo_white ? item.logo_white : item.logo}
                  className={classes.iconSize}
                />
              ) : (
                <img alt="Coin" src={item.logo} className={classes.iconSize} />
              )} */}
                <span>
                  <img
                    // cacheRequests={true}
                    src={
                      item.coinId == currentCoin
                        ? item.activeIconUrl
                        : item.inactiveIconUrl
                    }
                    width={20}
                    height="auto"
                    alt={item.coinId}
                  />
                </span>
              </Tooltip>
            </ListItemAvatar>
            <ListItemText
              primary={
                <div
                  style={{
                    display: "flex",
                    overflow: "hidden",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "center",
                  }}
                >
                  <div style={{ marginLeft: "5px", minWidth: "55px" }}>
                    <p className={classes.ptitle}>{item.coinId}</p>
                    {/* <p className={classes.pvalue}>{item.stock}%</p> */}
                  </div>
                  <Grid container>
                    <Grid item>
                      <p
                        style={{
                          margin: 0,
                          color: "#3AC4AB",
                          fontSize: "13px",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>Buy: </span>
                        <Tooltip
                          title={
                            <span
                              style={{
                                fontSize: 12,
                                margin: 4,
                                lineHeight: "normal",
                              }}
                            >
                              {prices[`${item.coinId}INR`]
                                ? JSON.stringify(
                                    prices[`${item.coinId}INR`]["a"]
                                  )
                                : null}
                            </span>
                          }
                        >
                          <span>
                            {prices[`${item.coinId}INR`]
                              ? prices[`${item.coinId}INR`]["a"]
                              : null}
                          </span>
                        </Tooltip>
                      </p>
                      <p
                        style={{
                          margin: 0,
                          color: "#D4535A",
                          fontSize: "13px",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>Sell: </span>
                        <Tooltip
                          title={
                            <span
                              style={{
                                fontSize: 12,
                                margin: 4,
                                lineHeight: "normal",
                              }}
                            >
                              {prices[`${item.coinId}INR`]
                                ? JSON.stringify(
                                    prices[`${item.coinId}INR`]["b"]
                                  )
                                : null}
                            </span>
                          }
                        >
                          <span>
                            {prices[`${item.coinId}INR`]
                              ? prices[`${item.coinId}INR`]["b"]
                              : null}
                          </span>
                        </Tooltip>
                      </p>
                    </Grid>
                  </Grid>
                  <Grid justify="flex-end">
                    <Grid item>
                      {favList.includes(item.coinId) ? (
                        <div
                          onClick={(e) => {
                            dispatch({
                              type: "DELETE_FAV_PRICE",
                              payload: item.coinId,
                            });
                          }}
                          data-identifier="star"
                        >
                          <StarIcon
                            style={{
                              marginLeft: "4px",
                              color: "#ffd900",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          data-identifier="star"
                          onClick={() => {
                            dispatch({
                              type: "ADD_FAV_PRICE",
                              payload: item.coinId,
                            });
                          }}
                        >
                          <StarBorderIcon
                            style={{
                              marginLeft: "4px",
                              color: "#A9A9A9",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </div>
              }
            />
          </ListItem>
          {drawerOpen ? <Divider /> : null}
        </div>
      ) : null
    );
    return list;
  };
  return prices ? (
    <>
      <List
        // className={classes.root}
        // style={{
        //   overflow: drawerOpen ? "scroll" : null,
        //   maxHeight: drawerOpen ? "80vh" : null,
        // }}
        // className={clsx(classes.root, {
        //   [classes.whenOpen]: drawerOpen,
        // })}
        className={clsx({
          [classes.root]: true, //always applies
          [classes.whenOpen]: drawerOpen, //only when open === true
        })}
      >
        {renderList(data, prices)}
        <div id="go-to-bottom-anchor"></div>
      </List>
      {drawerOpen ? (
        <ScrollTop {...props}>
          <Fab color="primary" size="small" aria-label="scroll back to top">
            <KeyboardArrowDownIcon style={{ color: "white" }} />
          </Fab>
        </ScrollTop>
      ) : null}
    </>
  ) : null;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.type === "dark" ? "#141828" : "white",
    padding: 0,
  },
  whenOpen: {
    overflow: "scroll",
    [theme.breakpoints.up("lg")]: {
      maxHeight: "80vh",
    },
    [theme.breakpoints.only("md")]: {
      maxHeight: "118vh",
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "80vh",
    },
  },
  inline: {
    display: "inline",
    color: "#299960",
  },
  primaryContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  secondaryTextContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  dividerStyles: {
    height: "3px",
  },
  iconSize: {
    // [theme.breakpoints.down('sm')]: {
    //   width: theme.spacing(3),
    //   height: theme.spacing(3),
    // },
    // [theme.breakpoints.up('md')]: {
    //   width: theme.spacing(4),
    //   height: theme.spacing(4),
    // }
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  ptitle: {
    margin: 0,
    fontSize: "12px",
    fontWeight: "bold",
  },
  pvalue: {
    margin: 0,
    fontSize: "14px",
  },
  drawerList: {
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "18px", //13px
      paddingTop: "8px", //16px
    },
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "18px", //18px
      // paddingTop: "10px",
    },
    paddingRight: "18px", //18px
    // paddingBottom: '10px',
    "&:hover": {
      cursor: "pointer",
    },
  },
  downarrow: {
    position: "fixed",
    bottom: theme.spacing(2),
    left: theme.spacing(26),
  },
}));

export default CoinList;
